export enum DateStringFormat {
  Long = 'long',
  Short = 'short',
  Narrow = 'narrow',
}

export enum DateNumberFormat {
  TwoDigit = '2-digit',
  Numeric = 'numeric',
}

export enum DateValueFormat {
  Long = 'long',
  Short = 'short',
  Narrow = 'narrow',
  TwoDigit = '2-digit',
  Numeric = 'numeric',
}

export type DateFormatConfig = {
  weekday?: DateStringFormat;
  month?: DateValueFormat;
  day?: DateNumberFormat;
  dayPeriod?: DateStringFormat;
  year?: DateNumberFormat;
};

/**
 * Date Format Style
 *
 * @examaple: Full = "Monday, April 15, 2020"
 * @examaple: Short = "Apr 15, 2020"
 * @examaple: Numeric = "4/15/2020"
 */
export enum DateFormat {
  // en-US: Monday, April 15, 2020
  Full = 'full',

  // en-US: Apr 15, 2020
  Short = 'short',

  // en-US: 4/15/2020
  Numeric = 'numeric',
}

export enum TimezoneOffsetFormat {
  Short = 'short',
  Long = 'long',
  ShortOffset = 'shortOffset',
  Offset = 'longOffset',
  ShortGeneric = 'shortGeneric',
  Generic = 'longGeneric',
}

export type TimeFormatConfig = {
  hour?: DateNumberFormat;
  minute?: DateNumberFormat;
  hour12?: boolean;
  timeZone?: string;
  timeZoneName?: TimezoneOffsetFormat;
};

export enum TimeFormat {
  Locale = 'Locale',
  TwelveHour = '12hr',
  Military = '24hr',
}

export type IntlDateTimeFormatOptions = DateFormatConfig & TimeFormatConfig;
